<template lang='pug'>
  .fpui-status-value
    | {{value}}
    span(v-if="limit") /{{limit}}
</template>

<script>

export default {
  props: {
    value: [Number, String],
    limit: Number
  },
  data () {
    return {
    }
  }
}
</script>

<style lang='less'>
  .fpui-status-value {

  }
</style>
